<template>
  <v-container>
    <v-row>
      <v-col class="xs-12 md-6">
        <v-card>
          <v-toolbar>
            <v-toolbar-title class="ml-3 mr-3">{{$t('Project.Settings.Message.MessageBoard.Title')}}</v-toolbar-title>
          </v-toolbar>
          <div class="project-message-board">
            <StandardMessage
              :readonly="false"
              :context_users="getProjectMembersForMessage(project_id)"
              :current_user="getUser"
              :project="getProject(project_id)"
              @sendMessage="sendMessage($event)"
              ref="twpMsg"
            />
            <div class="no-scroll-y">
              <StandardFlexBox
                height="calc(100% - 44px)"
                id="logList"
                direction="column"
                :no_wrap="true"
                >
                <!-- :icon="getLogListIcon(msg)" -->
                <StandardDataField
                  class="pa-1 mb-1"
                  v-for="msg in JSON.parse(JSON.stringify(getMessagesProject(project_id))).reverse()"
                  :key="msg.id"
                  :header="`${msg.created.substring(0, 19)}`"
                  :icon="getMessageIcon(msg)"
                  :value="msg.text"
                  :readonly="true"
                  width="100%"

                  />
              </StandardFlexBox>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col v-if="getMessagesProjectWarningActive(project_id).length + getMessagesProjectNotificationActive(project_id).length > 0" class="xs-12 md-6">
        <v-card>
          <v-toolbar>
            <v-toolbar-title class="ml-3 mr-3">{{$t('Project.Settings.Message.ActiveMessages.Title')}}</v-toolbar-title>
          </v-toolbar>
          <div class="project-message-board">
            <div class="no-scroll-y">
              <StandardFlexBox
                height="calc(100% - 44px)"
                id="logList"
                direction="column"
                :no_wrap="true"
                >
                <!-- :icon="getLogListIcon(msg)" -->
                <StandardDataField
                  class="pa-1 mb-1"
                  v-for="msg in JSON.parse(JSON.stringify(getMessagesProjectWarningActive(project_id))).reverse()"
                  :key="'warningactive' + msg.id"
                  :header="`${msg.created.substring(0, 19)}`"
                  :icon="getMessageIcon(msg)"
                  :value="msg.text"
                  :readonly="true"
                  width="100%"

                  />
                <StandardDataField
                  class="pa-1 mb-1"
                  v-for="msg in JSON.parse(JSON.stringify(getMessagesProjectNotificationActive(project_id))).reverse()"
                  :key="'notificationactive' + msg.id"
                  :header="`${msg.created.substring(0, 19)}`"
                  :icon="getMessageIcon(msg)"
                  :value="msg.text"
                  :readonly="true"
                  width="100%"

                  />
              </StandardFlexBox>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import store from '@/store/index'
import StandardMessage from '@/components/StandardComponents/StandardMessage.component.vue'
import StandardFlexBox from '@/components/StandardComponents/StandardFlexBox.component.vue'
import StandardDataField from '@/components/StandardComponents/StandardDataField.component.vue'

import { mapGetters, mapActions } from 'vuex';
export default {
  components: {
    StandardMessage, StandardFlexBox, StandardDataField
  },
  name: 'ProjectMessageBoard',
  beforeRouteEnter(to, from, next) {
    store.dispatch('Message/requestMessagesProject', {
      project_id: to.params.project_id
    })
    .then(() => {
      next();
    });
  },
  computed: {
    ...mapGetters('Message', [
      'getMessagesProject',
      'getMessagesProjectWarningActive',
      'getMessagesProjectNotificationActive'
    ]),
    ...mapGetters('Project', [
      'getProject'
    ]),
    ...mapGetters('ProjectMember', [
      'getProjectMembersForMessage',
    ]),
    ...mapGetters('Auth', [
      'getUser'
    ]),
    project_id() {
      return parseInt(this.$route.params.project_id);
    },
  },
  methods: {
    ...mapActions('Message', [
      'requestSendMessage'
    ]),
    sendMessage(msg){
      let add_project = true;
      for (var i = 0; i < msg.projects.length; i++) {
        if (msg.projects[i].id === this.project_id) {
          add_project = false;
          break;
        }
      }
      if (add_project) {
        msg.projects.push({ id: this.project_id});
      }
      this.requestSendMessage(msg);
      this.$refs.twpMsg.clearMessageText();
    },
    getMessageIcon(msg){
      if (msg.type === 'warning') {
        return 'warning';
      } else {
        return 'notifications';
      }
    }
  }
}
</script>
<style>
  div {
    user-select: none;
  }
  .no-scroll-y {
    overflow-y: hidden !important;
  }
  .project-message-board {
    background-color: #eee;
    height: 600px;
    padding: 10px 5px;
    color: black;
    overflow-y: scroll;
  }
</style>
